import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { getProjectCostSheet } from '../services/firestoreService';
import { generateProjectCostSheetPDF } from '../services/pdfService';
import PageHero from '../components/common/PageHero';
import Button from '../components/common/Button';
import Card from '../components/common/Card';
import Table from '../components/common/Table';
import {
  formatCurrency,
  formatDate,
  getActiveProjectCostLines,
  computeProjectCostTotals,
  getServiceTypeLabel
} from '../utils/helpers';
import toast from 'react-hot-toast';

const ProjectCostSheets = () => {
  const navigate = useNavigate();
  const { projectCostSheets, loadingProjectCostSheets } = useApp();

  const handleDownloadPdf = async (e, sheet) => {
    e.stopPropagation();
    try {
      let data = sheet;
      if (!sheet.lines?.length) {
        const result = await getProjectCostSheet(sheet.id);
        if (!result.success) {
          toast.error('Lama helin');
          return;
        }
        data = result.data;
      }
      const totals = computeProjectCostTotals(data);
      await generateProjectCostSheetPDF({ ...data, ...totals });
      toast.success('PDF waa la soo dejiyay');
    } catch {
      toast.error('PDF khalad');
    }
  };

  const columns = [
    {
      key: 'title',
      label: 'Sheet',
      render: (_, row) => (
        <div>
          <p className="font-semibold text-gray-900">{row.title || row.customerName || 'Sheet'}</p>
          {row.customerName && row.title ? (
            <p className="text-xs text-gray-500">{row.customerName}</p>
          ) : null}
        </div>
      )
    },
    {
      key: 'jobDate',
      label: 'Taariikh',
      render: (v) => formatDate(v)
    },
    {
      key: 'supervisor',
      label: 'Supervisor',
      render: (v) => v || '—'
    },
    {
      key: 'lines',
      label: 'Khado',
      render: (_, row) => {
        const n = getActiveProjectCostLines(row.lines || []).length;
        return <span className="text-gray-700">{n} la dooray</span>;
      }
    },
    {
      key: 'qarashkaTotal',
      label: 'Qarashka',
      render: (v, row) => (
        <span className="font-semibold text-red-600">
          {formatCurrency(v ?? computeProjectCostTotals(row).qarashkaTotal)}
        </span>
      )
    },
    {
      key: 'netIncome',
      label: 'Net',
      render: (v, row) => (
        <span className="font-semibold text-green-700">
          {formatCurrency(v ?? computeProjectCostTotals(row).netIncome)}
        </span>
      )
    },
    {
      key: 'status',
      label: 'Xaalad',
      render: (_, row) =>
        row.postedToKharashAt ? (
          <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full">Posted kharash</span>
        ) : (
          <span className="text-xs bg-slate-100 text-slate-600 px-2 py-1 rounded-full">Kaydsan</span>
        )
    },
    {
      key: 'actions',
      label: '',
      render: (_, row) => (
        <Button
          type="button"
          variant="outline"
          className="!py-1 !px-2 text-xs"
          onClick={(e) => handleDownloadPdf(e, row)}
        >
          PDF
        </Button>
      )
    }
  ];

  return (
    <div className="space-y-6">
      <PageHero
        title="Qarash Mashruuc"
        subtitle="Liiska sheets-ka — riix si aad u aragto faahfaahinta"
        actions={
          <Button onClick={() => navigate('/admin/project-costs/new')}>+ Sheet cusub</Button>
        }
      />
      <Card>
        <Table
          columns={columns}
          data={projectCostSheets}
          loading={loadingProjectCostSheets}
          emptyMessage="Sheet lama sameyn — samee mid cusub"
          onRowClick={(row) => navigate(`/admin/project-costs/${row.id}`)}
        />
      </Card>
      {projectCostSheets.length > 0 && (
        <p className="text-xs text-gray-500 text-center">
          {projectCostSheets.length} sheet · Adeegyada:{' '}
          {[...new Set(projectCostSheets.map((s) => s.serviceType).filter(Boolean))]
            .map((t) => getServiceTypeLabel(t))
            .join(', ') || '—'}
        </p>
      )}
    </div>
  );
};

export default ProjectCostSheets;
